import Backbone from 'backbone';
import $ from 'jquery';

import * as analytics from 'analytics/Analytics';
import {ANALYTICS_MODULE} from 'constants/AnalyticsConstants';
import {DNA_SEQUENCE_IMPORT_FLOW} from 'molbio/MolBioConstants';
import {openBatchSequenceImportModal} from 'nav/CreateDropdownActions';
// @ts-expect-error
import ifCreateFromHash from 'util/ifCreateFromHash';

class BatchSequenceImportView extends Backbone.View<Backbone.Model> {
  trackOpenModal(openedFrom: string): void {
    analytics.track('sequence', 'open_create_sequence_modal', {
      product: ANALYTICS_MODULE.MOLBIO,
      createdFrom: openedFrom,
      importFlow: DNA_SEQUENCE_IMPORT_FLOW.CHROMOSOME,
    });
  }

  handleCreate(): void {
    $(document).on('click', '.js-batch-sequence-import', (e) => {
      e.preventDefault();
      openBatchSequenceImportModal();
      this.trackOpenModal('global');
    });
    ifCreateFromHash('#batch-sequence-import', () => {
      openBatchSequenceImportModal();
      this.trackOpenModal('hash');
    });
  }

  render(): BatchSequenceImportView {
    this.handleCreate();
    return this;
  }
}

export default BatchSequenceImportView;
